module.exports = __webpack_public_path__ + "img/8.da7f0874.jpg";